module.exports = __webpack_public_path__ + "img/CU.a4b4e644.png";